/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconSoUrlRedirect = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps(iconProps);
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-label": "icon", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { d: "M18.105 2.316a.951.951 0 0 0-1.361-.056.994.994 0 0 0-.056 1.386l2 2.21h-3.894c-4.71 0-7.176 3.081-8.486 4.944l-2.55-3.794A.952.952 0 0 0 2.42 6.75a.993.993 0 0 0-.25 1.364L5.114 12.5l-2.947 4.386a.993.993 0 0 0 .251 1.364.952.952 0 0 0 1.34-.256L6.307 14.2c1.31 1.863 3.776 4.944 8.486 4.944h3.893l-1.999 2.21a.994.994 0 0 0 .056 1.386.951.951 0 0 0 1.361-.056L22 18.379l-3.874-4.568a.951.951 0 0 0-1.36-.101.994.994 0 0 0-.098 1.383l1.771 2.09h-3.645c-3.973 0-5.796-2.571-7.086-4.39-.071-.1-.14-.198-.21-.293l.21-.293c1.29-1.819 3.114-4.39 7.086-4.39h3.645l-1.771 2.09a.994.994 0 0 0 .099 1.383.951.951 0 0 0 1.359-.1L22 6.62l-3.895-4.305Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconSoUrlRedirect.displayName = 'IconSoUrlRedirect';
export default IconSoUrlRedirect;
